import React from "react";
import PathwayOverviewTable from "./PathwayOverviewTable";
import BreadCrumb from "../../../layout/BreadCrumb";
import PathwayCards from "./PathwayCards";

function PathwayOverviewList() {
  return (
    <div>
      <BreadCrumb breadcrumbs={[{ title: `Pathways` }]} />
      <div className="white_card mt-[1.25rem] flex-1 min-h-[80vh]">
        <PathwayCards />
        <div className="mt-[2.5rem]">
         
          <PathwayOverviewTable />
        </div>
      </div>
    </div>
  );
}

export default PathwayOverviewList;
